<template>
    <div class="obj-list wrapper">

        <div class="page__card">
            <div class="page__card-title">
                <h1>{{ $t('unconfirmed_buildings') }}</h1>
                <div class="page__card-item">
                    <router-link :to="getStatusLink('new')" class="page__card-router"
                        active-class="page__card-router--active" exact>
                        <HStar class="router__icon" />
                        {{ $t('unattested_new') }}
                        <span class="building-count">{{ buildingCount.new || 0 }}</span>
                    </router-link>
                    <router-link :to="getStatusLink('review')" class="page__card-router"
                        active-class="page__card-router--active" exact>
                        <HReloadCircle class="router__icon" />
                        {{ $t('unattested_approved') }}
                        <span class="building-count">{{ buildingCount.review || 0 }}</span>
                    </router-link>
                    <router-link :to="getStatusLink('rejected')" class="page__card-router"
                        active-class="page__card-router--active" exact>
                        <HRemoveCircle class="router__icon" />
                        {{ $t('unattested_rejected') }}
                        <span class="building-count">{{ buildingCount.rejected || 0 }}</span>
                    </router-link>
                </div>
            </div>
            <Unattested />
        </div>
    </div>
</template>

<script>
import Unattested from '@/components/UnattestesBuilding.vue'
import HStar from '@/components/Icons/hStar.vue';
import HRemoveCircle from '../../components/Icons/hRemoveCircle.vue';
import HReloadCircle from '../../components/Icons/hReloadCircle.vue';

export default {
    components: {
        Unattested,
        HStar,
        HRemoveCircle,
        HReloadCircle
    },
    data() {
        return {
            buildingCount: []
        };
    },
    watch: {
        '$route': {
            deep: true,
            handler() {
                this.getBuildingCount();
            }
        }
    },
    computed: {
        role() {
            return this.$store.state.role;
        },
    },
    mounted() {
        this.getBuildingCount()
    },
    methods: {
        getStatusLink(status) {
            const currentQuery = { ...this.$route.query, status: status };
            return { path: this.$route.path, query: currentQuery };
        },
        getBuildingCount() {
            axios.get(`building/specificationscount/`)
                .then((res) => {
                    this.buildingCount = res.data
                })
        }
    },
};
</script>
<style lang="scss" scoped>
.building-count {
    padding: 4px;
    font-size: 12px;
    line-height: 16px;
    border-radius: 8px;
    font-weight: 600;
    background: #E11D48;
    color: #fff;
    min-width: 24px;
    display: flex;
    justify-content: center;
}
.page__card-item {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
}

.page__card-router {
    padding: 7px 15px;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    transition: all 0.3s ease;
    color: #1E293B;
    display: flex;
    align-items: center;
    gap: 8px;

    .router__text {
        font-weight: 600;
        line-height: 22px;
    }

    .router__icon {
        color: #0891B2;
        width: 24px;
        height: 24px;
    }

    &:hover {
        background: #F1F5F9;
    }

    &--active {
        background: #3730A3;
        border: 1px solid #3730A3;
        color: white;

        &:hover {
            background: #4338CA;
            border: 1px solid #4338CA;
        }

        .router__icon {
            color: white;
        }
    }
    @media screen and (max-width: 575px) {
        padding: 6px 10px;
        width: 100%;
        .router__text{
            font-size: 14px;
            line-height: 1.375;
            text-align: start;
        }
    }
}

 
 
</style>
